module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\" id=\"upsell-container\">\n\t<div class=\"middle-box text-center animated fadeInRightBig\">\n\t\t<h3 class=\"font-bold\">Upgrade Required</h3>\n\t\t<div class=\"error-desc\">\n\t\t\tThis is an upgraded Tier 2 feature for an additional fee. To upgrade your service at a discounted CPAmerica member rate, please contact sales@prolaera.com\n\t\t</div>\n\t\t<a class=\"btn btn-primary btn-lg m-t-xl\"\n\t\t   href=\"mailto:sales@prolaera.com?subject=Upgrade Tier 2\">Contact</a>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/users/account/upgrade/template.html
// module id = 1041
// module chunks = 0